export const BREAKPOINTS = {
  desktop: 1440,
  ipad_pro: 1024,
  ipad_pro_portrait: 1366,
  ipad: 768,
  mobile: 429,
};

export const ARENA_GAME_TYPE = {
  cockFight: 0,
  taiXiu: 1,
};

export const RETRYWAITINGTIME: number = 10000;

export const ROUTE_NAME = {
  launch: 'launch',
  maintenance: 'maintenance',
  notFound: '404',
  notAuthorized: '403',
  cockFight: 'cock-fight',
  taiXiu: 'tai-xiu',
  sessionExpired: 'session-expired',
  video: 'video',
  videoReplay: 'video-replay',
};

export const CLIENT_VERSION = {
  default: 1,
  taiXiu: 2,
};

export const resolveClientVersion = (
  version?: string | number | null | (string | null)[]
): number => {
  const normalized = Array.isArray(version) ? version[0] : version;
  return Number(normalized) === CLIENT_VERSION.taiXiu ? CLIENT_VERSION.taiXiu : CLIENT_VERSION.default;
};

/*
 * `focus=tx` on the launch URL: prefer a live Tài Xỉu arena and open the Tài Xỉu
 * client (v2) on it; with none open the launch falls back to the cockfight
 * client. Works alongside `v=2`, which forces the Tài Xỉu client. Any other
 * `focus` is a cockfight country filter.
 */
export const TAI_XIU_FOCUS = 'tx';

// sessionStorage key for the desktop client's per-pane arena selection.
export const DESKTOP_PANES_STORAGE_KEY = 'desktopPanes';

export const getGameRouteName = (clientVersion: number): string => {
  return clientVersion === CLIENT_VERSION.taiXiu ? ROUTE_NAME.taiXiu : ROUTE_NAME.cockFight;
};

/*
 * A chip the client refuses because the selection is at its limit opens the
 * same "Bet not successful" popup the server's own refusal does (error 19), so
 * cockfight and Tài Xỉu say it the same way.
 */
export const MAX_BET_REACHED_POPUP = {
  isErrorPopupOpen: true,
  errorHeading: 'Bet not successful',
  errorMsg: 'Selection amount limit is reached E19',
};

export const API_URLS = {
  CHECK_AUTH: 'game-launch',
  CHECK_AUTH_WITH_TOKEN: 'game-launch-token',
  FIGHT_HISTORY: 'fights/',
  FIGHT_RESULT: 'charts/fight-results/',
  BALANCE: 'wallet/balance',
  BET: 'bet',
  MY_BET: 'my-bets/',
  BET_HISTORY: 'tickets/',
  BET_HISTORY_TOTAL: 'tickets/totals',
  WEBSOCKET_URL: 'wss://ws.ga28-api.com/ws/v1/',
  WEBSOCKET_URL_DEV: 'wss://gc-ws-dev.dg8-api.com/ws/v1/',
  ARENAS: 'arenas/',
  ARENA_BET_TYPE_ODDS: 'bet-type-odds',
  ARENA_BET_CHIPS: 'bet-chips',
  JACKPOTS: 'jackpots/',
  JACKPOTS_TICKETS: 'jackpot-tickets/',
  JACKPOT_MEMBER_TICKETS: 'jackpots/member-jackpot-tickets/',
  JACKPOT_LUCKY_DRAWS_WINNERS: 'jackpots/lucky-draws/winners/',
  ANNOUNCEMENTS: 'announcements/',
  CONFIG: 'config',
  SCHEDULE: 'schedules/',
  MAINTENANCE: 'm.json',
  METRICS_LOGS: 'metrics/logs/',
};

// Metrics log types for POST /api/v1/metrics/logs/
export const GC_ALERT_LOG_TYPE = {
  OPEN_DEBUG_SCREEN: 1,
  RIGHT_CLICK: 2,
  IDLE_30_MIN: 3,
};

export const DEFAULT_VAL = {
  INIT_GAP_NUM: 14.5,
};

export const ERROR_MSG = {
  invalidToken: 'Your token has expired. Please exit and launch again.',
};

export const LANG_SELECTION = {
  defaultText: 'en',
  name: 'langs',
  data: [
    { id: 'en', text: 'English' },
    { id: 'vn', text: 'Viet' },
    { id: 'id', text: 'Indo' },
    { id: 'th', text: 'Thai' },
    { id: 'zh', text: 'Chinese' },
    { id: 'hant', text: 'Traditional Chinese' },
    { id: 'es', text: 'Espanol' },
    { id: 'pk', text: 'Pakistan' },
    { id: 'jp', text: 'Japanese' },
    { id: 'kr', text: 'Korean' },
    { id: 'mm', text: 'Burmese' },
    { id: 'bd', text: 'Bengali-Bangladesh' },
    { id: 'in', text: 'Hindi-India' },
    { id: 'kh', text: 'Khmer' },
    { id: 'pt', text: 'Portuguese' },
    { id: 'uz', text: 'Uzbek' },
  ],
};
